import { TimeZoneStrings } from 'enums/TimeZone'
import { getYearDateDisplayNumeric, getYearDateHourMinuteDisplayNumeric } from 'utils/timeZoneUtil'

// eslint-disable-next-line import/prefer-default-export
export const formatTimeRange = (
  { start, end }: { start?: number; end?: number },
  timeZone: TimeZoneStrings
): string => {
  if (!start || !end) {
    return ''
  }

  const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000 // 86400000
  const isDurationAboveDay = end - start > MILLISECONDS_PER_DAY
  const formatStart = isDurationAboveDay
    ? getYearDateDisplayNumeric(start, timeZone)
    : getYearDateHourMinuteDisplayNumeric(start, timeZone)
  const formatEnd = isDurationAboveDay
    ? getYearDateDisplayNumeric(end - 1, timeZone)
    : getYearDateHourMinuteDisplayNumeric(end - 1, timeZone)

  return `${formatStart} - ${formatEnd}`
}
